export default "__VITE_ASSET__UOX2z6FF__"